import { useEffect, useState } from "react";
import { Share2 } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export default function ShareGuide({ title, slug, className = "" }) {
  const { lang } = useLang();
  const [count, setCount] = useState(0);
  const url = typeof window !== "undefined" ? window.location.href : "";
  const msg = lang === "es"
    ? `Mira esta guía de Hola Movers — ${title}: ${url}`
    : `Check out this Hola Movers guide — ${title}: ${url}`;

  useEffect(() => {
    if (slug) api.get(`/guides/${slug}/shares`).then((r) => setCount(r.data.count || 0)).catch(() => {});
  }, [slug]);

  const trackShare = () => {
    if (!slug) return;
    setCount((c) => c + 1);
    api.post(`/guides/${slug}/share`).catch(() => {});
  };

  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(msg)}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackShare}
        data-testid="share-guide-whatsapp"
        className="inline-flex items-center gap-2 rounded-full bg-white/80 backdrop-blur border border-sand-300 px-4 py-2 text-sm font-medium text-charcoal-700 hover:text-terracotta hover:border-terracotta/40 transition-colors"
      >
        <Share2 size={15} strokeWidth={1.75} />
        {lang === "es" ? "Compartir por WhatsApp" : "Share on WhatsApp"}
      </a>
      {count >= 3 && (
        <span data-testid="share-guide-count" className="text-xs text-charcoal-500">
          {lang === "es" ? `Compartida ${count} veces` : `Shared ${count} times`}
        </span>
      )}
    </span>
  );
}
